import SeparateLines from './SeparateLines.vue'
export default SeparateLines



// WEBPACK FOOTER //
// ./src/components/separate-lines/index.js